import { render, staticRenderFns } from "./ModalProductPhotos.vue?vue&type=template&id=c4724e56&scoped=true&"
import script from "./ModalProductPhotos.vue?vue&type=script&lang=js&"
export * from "./ModalProductPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4724e56",
  null
  
)

export default component.exports